<template>
	<v-card>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense class="mb-n5">
						<v-col cols="12" class="d-flex flex-wrap mt-2 ml-2">
							
							<div style="width: 200px;" class="mr-1">
								<v-text-field v-model="query.studentNo" label="学号" dense outlined></v-text-field>
							</div>
							<!-- <div style="width: 200px;" class="mr-1">
								<v-text-field v-model="query.studentName" label="姓名" dense outlined></v-text-field>
							</div> -->
							<studentSearchBox @inputValue="setInputValue"></studentSearchBox>
							<div style="width: 200px;" class="mr-1">
								<v-select :items="statusItems" v-model="query.status" item-text="statusName" item-value="id"
									label="状态" dense outlined></v-select>
							</div>
							<div style="width: 300px;" class="mr-1 d-flex">
								<v-text-field v-model="query.balanceFrom" label="余额>=" dense outlined></v-text-field>
								<v-text-field v-model="query.balanceTo" label="余额<=" dense outlined class="ml-1"></v-text-field>
							</div>
							<v-btn @click="queryClicked" color="primary">查询</v-btn>
						</v-col>
					</v-row>
					<v-divider></v-divider>
				</template>
				<template v-slot:item.status="{item}">
					<!-- <v-chip small :color="statusColor(item.status)">
					</v-chip> -->
					<span v-if="item.status == '0'" style="color:red">{{ statusName(item.status) }}</span>
					<span v-if="item.status == '1'">{{ statusName(item.status) }}</span>
				</template>
				<template v-slot:item.action="{item}">
					<v-menu top>
						<template v-slot:activator="{ attrs, on }">
							<v-btn v-bind="attrs" v-on="on" color="deep-purple lighten-3" small style="color: #424242;">
								操作
							</v-btn>
						</template>
						<v-list color="white" class="align-center">
							<v-list-item class="justify-center" v-if="item.status==='1'">
								<v-btn @click.stop="showAddDialog(item)" color="deep-purple lighten-3" small style="color: #424242;">金额充值</v-btn>
							</v-list-item>
							<v-list-item class="justify-center" v-if="item.status==='1'">
								<v-btn @click.stop="showReduceDialog(item)" color="deep-purple lighten-3" small style="color: #424242;" class="ml-1">扣减金额</v-btn>
							</v-list-item>
							<v-list-item class="justify-center" v-if="item.status=='1'">
								<v-btn @click.stop="cancelAccount(item)" color="deep-purple lighten-3" small style="color: #424242;" class="ml-1">冻结账户</v-btn>
							</v-list-item>
							<v-list-item class="justify-center" v-if="item.status=='0'">
								<v-btn  @click.stop="openAccount(item)" color="deep-purple lighten-3" small style="color: #424242;" class="ml-1">启用账户</v-btn>
						
							</v-list-item>
							<v-list-item class="justify-center" v-if="parseFloat(item.balanceFee) > 0">
								<v-btn  @click.stop="showRefund(item)" color="deep-purple lighten-3" small style="color: #424242;" class="ml-1">金额退费</v-btn>
							</v-list-item>
						</v-list>
					</v-menu>
					
				</template>

				<template v-slot:body.prepend="{ headers }">
					<tr class="account-summary-row">
						<td v-for="(header, index) in headers" :key="header.value">
							<span v-if="index === 0" title="当前筛选条件下的全部记录">全部合计</span>
							<span v-else>{{ summaryCells[header.value] }}</span>
						</td>
					</tr>
				</template>
			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="1">
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="9" v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>

		<!-- 添加dialog -->
		<v-dialog title="学费充值" v-model="add.dialog" max-width="600" persistent>
			<v-card>
				
				<v-card-title style="background-color:#9575CD; height: 55px;">
					<span style="color:#ffffff; font-size: 18px;" class="mt-n1">金额充值</span>
					<v-spacer></v-spacer>
					<v-icon color="white" @click="add.dialog=false">mdi-close-circle</v-icon>
				</v-card-title>
				<v-card-text>
					<v-sheet class="dark pa-4 rounded">
						<v-row dense>
							<v-col cols="12" class="mb-4">
								<span style="color:red; font-size: 16px;">注：学费用于支付“按金额扣费”的课程,不可用于“按课时扣费”的课程</span>
							</v-col>
							<v-col cols="6" class="pr-3">
								<v-text-field label="学号" disabled v-model="add.recharge.studentNo" dense
									outlined></v-text-field>
							</v-col>
							<v-col cols="6" class="pr-3">
								<v-text-field label="姓名" disabled v-model="add.recharge.studentName" dense
									outlined></v-text-field>
							</v-col>
							<v-col cols="12" class="pr-3 mt-n3">
								<v-text-field label="当前学费余额" v-model="add.recharge.balanceFee" disabled dense outlined>
								</v-text-field>
							</v-col>
							
							<v-col cols="6" class="mt-n3">
								<v-select :items="selectTeacherList" v-model="add.recharge.salesTeacherId" item-text="trueName"
									item-value="id" label="开单老师" dense outlined clearable></v-select>
							</v-col>
							<v-col cols="6" class="mt-n3">
								<v-select :items="selectTeacherList" v-model="add.recharge.classTeacherId" item-text="trueName"
									item-value="id" label="上课老师" dense outlined clearable></v-select>
							</v-col>
						
							<v-col cols="6" class="pr-3 mt-n3">
								<v-text-field label="充值金额" v-model="add.recharge.orderAmount" type="number" dense outlined>
								</v-text-field>
							</v-col>
							<v-col cols="6" class="pr-3 mt-n3">
								<v-text-field label="赠送金额" v-model="add.recharge.giveFee" type="number" dense outlined>
								</v-text-field>
							</v-col>
							<v-col cols="6" class="pr-3 mt-n3">
								<v-select label="请选择优惠券" v-model="add.selectedCoupon" 
								:items="studentCouponItems" item-text="couponName" item-value="id" 
								no-data-text="没有可用优惠券" :disabled="!add.recharge.orderAmount"
								return-object clearable @change="cashCouponChanged"
								dense outlined></v-select>
							</v-col>
							<v-col cols="6" class="pr-3 mt-n3">
								<v-text-field label="优惠券金额" v-model="couponAmount" disabled dense outlined>
								</v-text-field>
							</v-col>
							<v-col cols="6" class="pr-3 mt-n3">
								<v-text-field label="本次增加学费金额" v-model="addTuitionFee" disabled type="number" dense outlined>
								</v-text-field>
							</v-col>
							<v-col cols="6" class="pr-3 mt-n3">
								<!-- <v-text-field label="实付金额" v-model="realPayFee" disabled type="number" dense outlined>
								</v-text-field> -->
								<span class="mt-2">需付款金额:</span>
								<span style="color: red;" class="ml-2 mt-1 text-h6">{{realPayFee}}</span>
								<span class="mt-2 ml-1">元</span>
							</v-col>
							<v-col cols="4" class="pr-3 mt-n3">
								<v-select v-model="add.recharge.payType" :items="payTypeList" label="付款方式" item-text="text"
									item-value="code" clearable outlined dense no-data-text="暂无付款方式"></v-select>
							</v-col>
							<v-col cols="8" class="pr-3 mt-n3">
								<v-text-field label="备注" v-model="add.recharge.memo" dense outlined>
								</v-text-field>
							</v-col>
						</v-row>
					</v-sheet>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="add.dialog=false">取消</v-btn>
					<v-btn @click="submitAddRecharge" :disabled="add.submitting" :loading="add.submitting" color="info">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- 扣除dialog -->
		<v-dialog title="扣除学费" v-model="reduce.dialog" max-width="600" persistent>
			<v-card>
				<v-card-title style="background-color:#9575CD; height: 55px;">
					<span style="color:#ffffff; font-size: 18px;" class="mt-n1">扣除金额</span>
					<v-spacer></v-spacer>
					<v-icon color="white" @click="reduce.dialog=false">mdi-close-circle</v-icon>
				</v-card-title>
				<v-card-text>
					<v-sheet class="dark pa-4 rounded">
						<v-row class="mt-3" dense>
							<v-col cols="6">
								<v-text-field label="学号" disabled v-model="reduce.order.studentNo" dense
									outlined></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-text-field label="姓名" disabled v-model="reduce.order.studentName" dense
									outlined></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-text-field label="当前学费余额" v-model="reduce.order.balanceFee" disabled dense outlined>
								</v-text-field>
							</v-col>
							<v-col cols="6">
								<v-text-field label="当前现金余额" v-model="reduce.order.balanceRealFee" disabled dense outlined>
								</v-text-field>
							</v-col>
							<v-col cols="6">
								<v-text-field label="本次扣除金额" v-model="reduce.order.reduceAmount" type="number" dense outlined>
								</v-text-field>
							</v-col>
						
							<v-col cols="12">
								<v-text-field label="备注" v-model="reduce.order.memo" dense outlined>
								</v-text-field>
							</v-col>
						</v-row>
					</v-sheet>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="reduce.dialog=false">取消</v-btn>
					<v-btn @click="submitReduceAmount" :disabled="reduce.submitting" :loading="reduce.submitting" color="info">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<!-- 金额退费组件 -->
		<cashAccountRefund :show="refund.show" :account="refund.account" @cancel="refund.show=false" @success="refundSuccess"></cashAccountRefund>


	</v-card>
</template>

<script>
	import global from '../../../config/global'
	import utils from "../../../config/utils"
	import cashAccountRefund from "../../../components/cash_account_refund.vue"
	import studentSearchBox from "../../../components/student_search_box.vue"
	export default {
		name: "student-cash-list",
		components:{cashAccountRefund,studentSearchBox},
		data() {
			return {
				
				imgPrev: global.config.imgPre,
				data: {
					total: 0,
					headers: [
						{
							text: '学号',
							value: 'studentNo',
							sortable: false
						},
						{
							text: '姓名',
							value: 'studentName',
							sortable: false
						},
						{
							text: '总学费',
							value: 'totalTuitionFee',
							sortable: false
						},
						{
							text: '已用学费',
							value: 'usedFee',
							sortable: false
						},
						{
							text: '剩余学费',
							value: 'balanceFee',
							sortable: false
						},
						{
							text: '实缴金额',
							value: 'realPayFee',
							sortable: false
						},
						{
							text: '已用金额',
							value: 'usedRealFee',
							sortable: false
						},
						{
							text: '剩余金额',
							value: 'balanceRealFee',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '操作',
							value: 'action',
							sortable: false
						},
					],
					list: [],
					summary: null,
				},
				listRequestId: 0,
				studentCouponItems:[], // 选择的优惠券
				selectTeacherList:[],
				statusItems: [{
						id: "",
						statusName: "全部"
					},
					{
						id: "1",
						statusName: "正常"
					},
					{
						id: "0",
						statusName: "作废"
					},
				],

				query: {
					loading: false,
					page: 1,
					size: 20,
					studentNo: "",
					studentName: "",
					status: "1",
					balanceFrom:"",
					balanceTo:""
				},
				payTypeList:[
					{code:'ALIPAY',text:'支付宝'},
					{code:'WXPAY',text:'微信'},
					{code:'CASH',text:'现金'},
				],
				add: {
					dialog: false,
					submitting: false,
					selectedCoupon:null, //选择的优惠券
					recharge: {
						cashId: "", // 账号ID
						studentNo: "",
						studentName: "",
						balanceFee:"",  //当前余额
						orderAmount: "", //学费金额
						giveFee:"",  	//赠送金额
						memo:"",
						payType:"",
						salesTeacherId:"",
						classTeacherId:""
					},
				},
				reduce:{
					dialog:false,
					submitting: false,
					order: {
						cashId: "", // 账号ID
						studentNo: "",
						studentName: "",
						balanceFee:"",  //当前余额
						balanceRealFee:"",
						reduceAmount: "", //扣除金额
						memo:"",
					},
				},
				refund:{
					show:false,
					account:null
				}
			}
		},
		created() {

			this.getTableDataList();
			this.getTeacherListForSelect();
		},
		computed:{
			summaryCells(){
				const cells = {};
				const moneyFields = ['totalTuitionFee', 'usedFee', 'balanceFee', 'realPayFee', 'usedRealFee', 'balanceRealFee'];
				const hourFields = [];
				moneyFields.concat(hourFields).forEach(field => {
					const value = this.data.summary && this.data.summary[field];
					if (this.query.loading || value === null || value === undefined || value === '' || !Number.isFinite(Number(value))) {
						cells[field] = '—';
					} else {
						cells[field] = moneyFields.includes(field) ? Number(value).toFixed(2) : String(value);
					}
				});
				return cells;
			},

			realPayFee(){
				if(!this.add.recharge.orderAmount){
					return "0";
				}
				let orderAmount = this.add.recharge.orderAmount;
				let couponAmount = 0;
				if (this.add.selectedCoupon){
					couponAmount = this.add.selectedCoupon.amount;
				}
				let result = orderAmount - couponAmount;
				return result >0 ?result:0 ;
			},
			addTuitionFee(){
				if(!this.add.recharge.orderAmount){
					return "";
				}
				let orderAmount = parseFloat(this.add.recharge.orderAmount);
				let giveFee = 0;
				if (this.add.recharge.giveFee){
					giveFee = parseFloat(this.add.recharge.giveFee);
				}
				let result = orderAmount + giveFee;
				return result > 0 ? result:0;
			},
			couponAmount(){
				if(!this.add.selectedCoupon){
					return "0";
				}
				
				return this.add.selectedCoupon.amount;
			}
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			setInputValue(value){
				// 搜索框输入的值
				
				this.query.studentName = value;
			},
			cashCouponChanged(e){
			
				// 课时 优惠券选择
				let limitAmount = parseFloat(e.limitAmount);
				const cashAmount = parseFloat(this.add.recharge.orderAmount);
				if (limitAmount > 0){
					// 有金额限制 判断金额限制
					if (cashAmount < limitAmount){
						// 不符合
						
						this.$noty.error('优惠券需满'+limitAmount+'元才能使用');
						const that = this;
						setTimeout(()=>{
							that.add.selectedCoupon = null;
						},100)
					}
				}
				
			},
			showRefund(item){
				this.refund.account = item;
				this.refund.show=true;
			},
			refundSuccess(){
				this.getTableDataList();
				this.refund.show=false;
				
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			showAddDialog(item) {
				this.add.dialog = true;

				this.add.recharge.cashId = item.id;
				this.add.recharge.studentNo = item.studentNo;
				this.add.recharge.studentName = item.studentName;
				this.add.recharge.balanceFee = item.balanceFee;
				this.add.recharge.salesTeacherId = "";
				this.add.recharge.classTeacherId = "";
				
				
				// 获取学员优惠券
				this.add.selectedCoupon = null;
				this.getStudentCouponListForSelect(item.studentId);
				
			},
			showReduceDialog(item){
				// 扣费
				this.reduce.dialog = true;
				this.reduce.order.cashId = item.id;
				this.reduce.order.studentNo = item.studentNo;
				this.reduce.order.studentName = item.studentName;
				this.reduce.order.balanceFee = item.balanceFee;
				this.reduce.order.balanceRealFee = item.balanceRealFee;
				
				this.reduce.order.reduceAmount = "";
				this.reduce.order.memo = "";
			},
			submitAddRecharge(){
				// 提交充值
				if(!this.add.recharge.orderAmount){
					this.$noty.error("请输入学费金额")
					return
				}
				// 判断正2位小数金额
				const isFloat = utils.isDecimal(this.add.recharge.orderAmount);
				if (!isFloat){
					this.$noty.error('缴费金额格式错误,最多2位小数的正数');
					return;
				}
				// 如果输入了赠送金额
				if (this.add.recharge.giveFee){
					if(!utils.isDecimal(this.add.recharge.giveFee)){
						this.$noty.error('赠送金额格式错误,最多2位小数的正数');
						return;
					}
				}
				
				
				this.add.submitting = true;
				
				// api
				const that = this;
				let url = `/financial/student/cash/recharge`;
				let postData = {
					cashId:this.add.recharge.cashId,
					orderAmount :this.add.recharge.orderAmount,
					giveFee:this.add.recharge.giveFee,
					memo:this.add.recharge.memo,
					payType:this.add.recharge.payType,
					salesTeacherId:this.add.recharge.salesTeacherId,
					classTeacherId:this.add.recharge.classTeacherId
				}
				
				if(this.add.selectedCoupon){
					postData.studentCouponId = this.add.selectedCoupon.id;
				}
				
				this.axios.post(url, postData).catch(() => {
					that.add.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.add.dialog = false;
							that.add.submitting = false;
							return;
						} else {
							that.add.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.add.submitting = false;
						that.$noty.error('网络请求失败');
					}
				
				});
			},
			submitReduceAmount(){
				// 提交扣除学费
				if(!this.reduce.order.reduceAmount){
					this.$noty.error("请输入扣除学费金额")
					return
				}
				
				// 判断正2位小数金额
				const isFloat = utils.isDecimal(this.reduce.order.reduceAmount);
				if (!isFloat){
					this.$noty.error('请输入最多2位小数的金额');
					return;
				}

				this.reduce.submitting = true;
				// api
				const that = this;
				let url = `/financial/student/cash/reduce`;
				let postData = {
					cashId:this.reduce.order.cashId,
					reduceAmount :this.reduce.order.reduceAmount,
					memo:this.reduce.order.memo,
				}
				
				this.axios.post(url, postData).catch(() => {
					that.reduce.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							that.reduce.dialog = false;
							that.reduce.submitting = false;
							return;
						} else {
							that.reduce.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.reduce.submitting = false;
						that.$noty.error('网络请求失败');
					}
				
				});
			},
			getTableDataList() {
				
				if(this.query.balanceFrom){
					if(!utils.isDecimal(this.query.balanceFrom)){
						this.$noty.error('金额请输入最多两位小数的非负数字');
						return
					}
				}
				
				if(this.query.balanceTo){
					if(!utils.isDecimal(this.query.balanceTo)){
						this.$noty.error('金额请输入最多两位小数的非负数字');
						return
					}
				}
				
				if (this.query.balanceFrom !== '' && this.query.balanceTo !== '' && Number(this.query.balanceFrom) > Number(this.query.balanceTo)) {
					this.$noty.error('余额下限不能大于上限');
					return;
				}

				const requestId = ++this.listRequestId;
				this.query.loading = true;
				this.data.summary = null;
				const params = { shopId: utils.getCurrentShopId() };
				['studentNo', 'studentName', 'status', 'balanceFrom', 'balanceTo'].forEach(key => {
					const value = this.query[key];
					if (value !== '' && value !== null && value !== undefined) {
						params[key] = value;
					}
				});
				const url = `/financial/student/cash/list/page/${this.query.page - 1}/size/${this.query.size}`;
				return this.axios.get(url, { params }).then(response => {
					if (requestId !== this.listRequestId) return;
					if (response.data.code !== 200) {
						throw new Error(response.data.message || '获取失败');
					}
					const pageData = response.data.data;
					this.data.list = pageData.list || [];
					this.data.total = pageData.count;
					this.data.summary = pageData.summary || null;
				}).catch(error => {
					if (requestId !== this.listRequestId) return;
					this.data.list = [];
					this.data.total = 0;
					this.data.summary = null;
					this.$noty.error('获取失败：' + ((error && error.message) || '网络请求失败'));
				}).finally(() => {
					if (requestId === this.listRequestId) this.query.loading = false;
				});
			},
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "作废";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			cancelAccount(item){
				// 作废课时账户
				const cashId = item.id;
				const that = this;
				let url = `/financial/cash/account/cancel/` + cashId;
				
				this.axios.post(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.getTableDataList();
						return
					}
				
					that.$noty.error("操作失败：" + response.data["message"]);
				})
			},
			openAccount(item){
				// 作废课时账户
				const cashId = item.id;
				const that = this;
				let url = `/financial/cash/account/open/` + cashId;
				
				this.axios.post(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.getTableDataList();
						return
					}
				
					that.$noty.error("操作失败：" + response.data["message"]);
				})
			},
			getShopListForSelect() {
				const that = this;
				let url = `/sys/merchant/shop/list`;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectShopList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getStudentCouponListForSelect(studentId) {
				// 获取学生优惠券
				if (!studentId) {
					return
				}
				const that = this;
				let url = `/financial/student/all/coupon/list/` + studentId;
			
				this.axios.get(url).then(response => {
					
					console.log("student coupon:",response);
					if (response.data["code"] === 200) {
						that.studentCouponItems = response.data["data"] ? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getTeacherListForSelect() {
			
				const shopId = utils.getCurrentShopId();
				
				if (!shopId) {
					return
				}
			
				const that = this;
				let url = `/edu/shop/teacher/list/` + shopId;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						that.selectTeacherList = response.data["data"] ? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		
		}
	}
</script>

<style scoped>
	.account-summary-row {
		background-color: #ede7f6;
		font-weight: 600;
	}
	.account-summary-row td {
		white-space: nowrap;
		border-top: 2px solid #b39ddb;
	}

</style>
